import { render, staticRenderFns } from "./AddFormItem.vue?vue&type=template&id=57dfbb1e&scoped=true&"
import script from "./AddFormItem.vue?vue&type=script&lang=js&"
export * from "./AddFormItem.vue?vue&type=script&lang=js&"
import style0 from "./AddFormItem.vue?vue&type=style&index=0&id=57dfbb1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfbb1e",
  null
  
)

export default component.exports